import { render, staticRenderFns } from "./UserPortalServices.vue?vue&type=template&id=4fba35f8&"
import script from "./UserPortalServices.vue?vue&type=script&lang=js&"
export * from "./UserPortalServices.vue?vue&type=script&lang=js&"
import style0 from "./UserPortalServices.vue?vue&type=style&index=0&id=4fba35f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports